import { render, staticRenderFns } from "./logoBox.vue?vue&type=template&id=5c4a292c&scoped=true"
import script from "./logoBox.vue?vue&type=script&lang=js"
export * from "./logoBox.vue?vue&type=script&lang=js"
import style0 from "./logoBox.vue?vue&type=style&index=0&id=5c4a292c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4a292c",
  null
  
)

export default component.exports